(function () {
  function bindPause(el, instance) {
    var pause = function () { instance.pausePlayer && instance.pausePlayer(); };
    var resume = function () { instance.unpausePlayer && instance.unpausePlayer(); };
    el.addEventListener('mouseenter', pause);
    el.addEventListener('mouseleave', resume);
    el.addEventListener('focusin', pause);
    el.addEventListener('focusout', resume);
  }

  function init() {
    var heroes = document.querySelectorAll('[data-autoplay="true"][data-speed]');
    if (!heroes.length || typeof Flickity === 'undefined') return false;
    var bound = false;
    heroes.forEach(function (el) {
      if (el.__heroPauseBound) return;
      var instance = Flickity.data(el);
      if (!instance) return;
      el.__heroPauseBound = true;
      bindPause(el, instance);
      bound = true;
    });
    return bound;
  }

  if (!init()) {
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (init() || attempts > 40) clearInterval(poll);
    }, 250);
  }
})();
